import { render, staticRenderFns } from "./skype.vue?vue&type=template&id=f08488e2&"
import script from "./skype.vue?vue&type=script&lang=js&"
export * from "./skype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports